var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "h-100 pa-16px black--text",
    attrs: {
      "flat": "",
      "tile": "",
      "color": "white"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    staticClass: "w-60 w-md-100 mx-auto mb-14px",
    attrs: {
      "max-width": "240",
      "src": "/images/main/flebogrif.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 justify-center"
  }, [_c('u-tit-default', {
    staticClass: "font-size-12 font-size-md-24 font-size-lg-36"
  }, [_c('span', {
    staticClass: "font-weight-regular font-secondary"
  }, [_vm._v("플래보그립")]), _c('span', {
    staticClass: "font-size-16 font-size-md-36 font-size-lg-48"
  }, [_vm._v("  "), _c('ICountUp', {
    staticClass: "iCountUp",
    attrs: {
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": _vm.duration,
      "options": _vm.options
    }
  })], 1), _vm._v("례 이상 ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }